<template>
  <div>
    <div class="ui large modal" ref="modal">
      <i class="close icon"></i>
      <div class="header">{{ title }}</div>
      <div class="scrolling content">
        <div class="ui padded grid">
          <div class="row">
            <div class="twelve wide column">
              <img class="image-preview" ref="source" :src="objectUrl" />
            </div>
            <div class="four wide column">
              <div class="image-container">
                <img class="image-result" :src="previewCropped" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actions">
        <div @click="submitImage" class="ui approve primary button">Pronto</div>
      </div>
    </div>
    <input
      v-show="0"
      @change="onFileChange"
      type="file"
      ref="inputFile"
      accept="image/png, image/jpeg"
      visbility="hidden"
    />
    <div class="ui logo card">
      <div class="content">
        <div class="right floated meta">
          <a @click.prevent="remove">
            <i class="close icon"></i>
          </a>
        </div>
      </div>
      <div class="image" href="#">
        <img :src="imageURL" />
        <div v-show="loading" class="ui active inverted dimmer">
          <div class="ui text loader">Carregando...</div>
        </div>
      </div>
      <div class="content">
        <a @click="triggerInput" name="button">{{
          loading ? `${sentText} ...` : sentText
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Cropper from 'cropperjs';
import debounce from 'lodash/debounce';
import Api from '@/resources/Api';

export default {
  name: 'ImageInput',
  props: ['title', 'sentText', 'aspectRatio', 'item', 'item_id'],

  data() {
    return {
      loading: false,
      selectedFile: null,
      cropper: null,
      previewCropped: null,
      objectUrl: null,
      debouncedUpdatePreview: debounce(this.updatePreview, 257),
      imageURL: null
    };
  },

  watch: {
    item_id: function (newValue, oldValue) {
      if (oldValue == null && newValue != null) {
        this.fetch();
      }
    }
  },

  methods: {
    fetch() {
      this.loading = true;
      Api.images
        .fetch(this.item_id)
        .then(response => {
          this.imageURL = response.data.image.url;
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar imagem', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    remove() {
      if (this.item_id) {
        this.loading = true;
        Api.images
          .destroy(this.item_id)
          .then(() => {
            this.imageURL = null;
            this.$emit('selected', null);
            this.$toast.show('Imagem removida com sucesso', 'success');
          })
          .catch(error => {
            this.$toast.show('Erro ao remover imagem', 'error');
            throw error;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    setupCropper(selectedFile) {
      if (this.cropper) {
        this.cropper.destroy();
      }

      if (this.objectUrl) {
        window.URL.revokeObjectURL(this.objectUrl);
      }

      if (!selectedFile) {
        this.cropper = null;
        this.objectUrl = null;
        this.previewCropped = null;
        return;
      }

      this.objectUrl = window.URL.createObjectURL(selectedFile);
      this.$nextTick(this.setupCropperInstance);
    },

    setupCropperInstance() {
      this.cropper = new Cropper(this.$refs.source, {
        aspectRatio: this.aspectRatio || 1,
        crop: this.debouncedUpdatePreview
      });
    },

    updatePreview() {
      const canvas = this.cropper.getCroppedCanvas();
      this.previewCropped = canvas.toDataURL('image/png');
    },

    triggerInput() {
      if (!this.loading) {
        this.$refs.inputFile.click();
      }
    },

    onFileChange(evt) {
      const files = evt.target.files || evt.dataTransfer.files;
      if (!files.length) return;

      const file = files[0];
      this.setupCropper(file);

      window.$(this.$refs.modal).modal('show');
    },

    _sendFile(file) {
      this.loading = true;
      const formData = new FormData();
      formData.append('image[name]', this.item);
      formData.append('image[file]', file);

      return $.ajax({
        // xhr: () => {
        //   let xhr = $.ajaxSettings.xhr();
        //   xhr.upload.onprogress = evt => {
        //     const percent = (evt.loaded / evt.total) * 100;
        //     console.log(percent);
        //     // this.$refs.progress.setPercent(attachment.kind, percent)
        //   };
        //   return xhr;
        // },
        beforeSend: request => {
          request.setRequestHeader(
            'Access-token',
            this.$store.getters['user/token']
          );
        },
        success: data => {
          this.$toast.show('Imagem enviada com sucesso', 'success');
          this.imageURL = data.image.url;
          this.$emit('selected', data.image.id);
          this.loading = false;
          // this.currentImage = response.data.image;
          //
          // this.$emit('selected', this.currentImage.id);
        },
        error: () => {
          this.$toast.show('Erro ao enviar imagem', 'error');
          this.loading = false;
        },
        url: `${Api.baseURL}/images`,
        data: formData,
        processData: false,
        contentType: false,
        enctype: 'multipart/form-data',
        type: 'POST'
      });
    },

    submitImage() {
      const canvas = this.cropper.getCroppedCanvas();
      canvas.toBlob(blob => {
        this._sendFile(blob);
      });
    }
  }
};
</script>

<style lang="css" scoped>
.image-preview {
  display: block;
  max-height: 400px;
  max-width: 100%;
}

.image-container {
  display: flex;
  justify-content: center;
}

.image-result {
  max-height: 400px;
  max-width: 100%;
  margin: 0 auto;
}

.card .image {
  overflow-x: hidden;
}

.card .image img {
  width: auto;
  height: 150px;
  margin: 0 auto;
}
</style>
